module.exports = __webpack_public_path__ + "static/media/error.d1cc6108.svg";